<!--
 * @Author: ken yang
 * @Date: 2022-11-28 09:20:09
 * @LastEditTime: 2023-04-13 18:13:58
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_admin/src/layout/components/Sidebar/index.vue
-->
<template>
  <!-- {{ curFirstRoute }} -->
  <Column class="sidebar-container">
    <el-scrollbar view-class="w-100b" wrap-class="scrollbar-wrapper w-100b">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :unique-opened="false"
        :collapse-transition="false"
        mode="vertical"
        class="p-tb-16"
        router
      >
        <sidebar-item
          v-for="route in menuRouters"
          :key="route.path"
          :item="route"
          :collapse="isCollapse"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </Column>
</template>
<script setup>
import SidebarItem from './SidebarItem.vue'
import home from '@/view/home'
import agent from '@/view/agent'
import commissions from '@/view/commissions'
import futures from '@/view/futures'
import withdrawMoney from '@/view/withdrawMoney'

const userStore = useUserStore()
const isCollapse = $ref(false)
const activeMenu = $computed(() => {
  const route = router.currentRoute.value
  const { path } = route
  // if set path, the sidebar will highlight the path you set
  return path
})

const menuRouters = $computed(() => {
  return [
    home.routes,
    agent.routes,
    futures.routes,
    commissions.routes,
    withdrawMoney.routes,
    ...userStore.menuRouters,
  ]
})

const screenWidth = $ref(1700)
// eventBus.on('onResize', e => {
// if (screenWidth > window.innerWidth) {
//   isCollapse = true
// }
// })

const toHome = () => {
  router.push('/dashboard/HomePage')
}

</script>
<style lang="scss">
@use "sass:math";
@use "sass:map";
@import '@/sass/var/index.scss';

.sidebar-container{
  box-sizing: border-box;
  background-color: #FFF;
  .el-scrollbar{
    width: 100%;
  }
  .el-menu{
    --el-menu-item-height: 48px;
    --el-menu-base-level-padding: 20px;
    --el-menu-hover-bg-color: #{rgba($color-primary, 0.05)};
    border-right: 0px;
    .el-menu-item:hover{
      // background-color: red;
      background-color: $color-line;
    }
    .el-menu-item.is-active{
      background-color: var(--el-menu-hover-bg-color) !important;
    }
  }
}
</style>
